import { Input } from "@/components/ui/input";
import {
  coerceLinkFieldValueForSave,
  findFirstLinkFieldValidationError,
  linkFieldInputHtmlProps,
  validateLinkFieldValue,
} from "@/utils/linkFieldValue";

export { findFirstLinkFieldValidationError };

type Props = {
  fieldType: string;
  value: unknown;
  onChange: (next: string) => void;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  /** When set, shown instead of running validateLinkFieldValue locally. */
  error?: string | null;
  id?: string;
};

export function LinkFieldEditor({
  fieldType,
  value,
  onChange,
  required,
  disabled,
  placeholder,
  error: errorOverride,
  id,
}: Props) {
  const str = value == null ? "" : String(value);
  const validationError =
    errorOverride === undefined
      ? validateLinkFieldValue(fieldType, str, { required })
      : errorOverride;
  const inputProps = linkFieldInputHtmlProps(fieldType);

  return (
    <div className="space-y-1">
      <Input
        id={id}
        {...inputProps}
        value={str}
        disabled={disabled}
        placeholder={placeholder}
        aria-invalid={validationError ? true : undefined}
        className={validationError ? "border-destructive" : undefined}
        onChange={(e) => onChange(e.target.value)}
        onBlur={(e) => onChange(coerceLinkFieldValueForSave(e.target.value))}
      />
      {validationError ? (
        <p className="text-xs text-destructive" role="alert">
          {validationError}
        </p>
      ) : null}
    </div>
  );
}
